import $ from 'jquery';

$('.events-list-page__search button').on('click', function () {
    $('.events-list-page__search button').removeClass('active');
    $(this).addClass('active');

    $('.events-target').hide()
    $($(this).attr('data-filter')).show()
})
